<template>
  <div ref="loader-lazy">
    <div v-if="status === 'processing'" class="plc-loader">
      <loader class="plc-loader__svg" />
      <span class="plc-loader__text">Loading...</span>
    </div>
    <div v-if="status === 'completed'" class="plc-loader">
      <span class="plc-loader__text">No more results :(</span>
    </div>
  </div>
</template>

<script>
import Loader from '@/assets/img/loader.svg?inline'

export default {
  name: 'GlLoaderLazy',
  components: {
    Loader,
  },
  emits: ['load-more'],
  data() {
    return {
      visible: false,
      timer: null,
      status: 'processing', // completed | processing
    }
  },
  mounted() {
    this.timer = setInterval(() => {
      if (this.status === 'processing' && this.elementInViewport(this.$refs['loader-lazy']))
        this.$emit('load-more')
    }, 500)
  },
  beforeUnmount() {
    clearInterval(this.timer)
  },
  methods: {
    processing() {
      this.status = 'processing'
    },
    completed() {
      this.status = 'completed'
    },
    elementInViewport(el) {
      let top = el.offsetTop
      let left = el.offsetLeft
      const width = el.offsetWidth
      const height = el.offsetHeight

      while (el.offsetParent) {
        el = el.offsetParent
        top += el.offsetTop
        left += el.offsetLeft
      }

      return (
        top - 500 < window.pageYOffset + window.innerHeight &&
        left < window.pageXOffset + window.innerWidth &&
        top + height > window.pageYOffset &&
        left + width > window.pageXOffset
      )
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~styles/blocks/loader';

.plc-loader {
  margin-top: 16px;
}
</style>
